// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a10a3f92e9--wrapper--cyXsV"};